import React from 'react';
import { Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import WorkperiodsList from './WorkperiodsList';
import WorkperiodDetail from './WorkperiodDetail';

class Sales extends React.Component {
    render() {
        return (
            <TransitionGroup>
                <CSSTransition
                    key={this.props.location.key}
                    classNames="fade"
                    timeout={200}
                >
                    <div>
                        <Route exact path="/admin/sales" component={WorkperiodsList} />
                        <Route path="/admin/sales/:periodId" component={WorkperiodDetail} />
                    </div>
                </CSSTransition>
            </TransitionGroup>
        );
    }
}

export default withRouter(connect()(Sales));
